import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import AlertDetailsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AlertDetailsPage";
import Classes, { Account, NotificationDetail } from "model";
import { useEffect } from "react";

export default function CaptureNotifiLimAlertActive(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasConsumerAccounts = Account.hasConsumerAccounts(branding);
    const notification = NotificationDetail.initByID(hasConsumerAccounts ? "2" : "9");
    notification.contactInfoEnabledIDs = ["0", "1"];

    NotificationDetail.update(notification)
        .submit(Classes);
    
    const data = getDefaultPageData("26");
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ hasConsumerAccounts ? "Detail_2" : "Detail_9" ], { action: "added" })
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <AlertDetailsPage data={ data } ui={ ui } />
}